import React,{useState} from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import { handleEnter } from "../components/CommonFunections";

function Profile() {
  const [passwordShown, setPasswordShown] = useState(false);
  const [visibility,setVisibility] = useState(false);

  const [passwordShown2, setPasswordShown2] = useState(false);
  const [visibility2,setVisibility2] = useState(false);


  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
    setVisibility(visibility ? false : true);
  };

  const togglePasswordVisiblity2 = () => {
    setPasswordShown2(passwordShown2 ? false : true);
    setVisibility2(visibility2 ? false : true);
  };

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={8} className="rgc-request p-4 rgc-profile ">
            <div className="d-flex rgc-title">
              <div className="rgc-title-point"></div>
              <h4>پروفایل <span>کاربر</span></h4>
            </div>
            
            <Form>
              <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicName">
                <Form.Label>نام و نام خانوادگی</Form.Label>
                <i className='fas fa-user-alt'></i>
                <Form.Control
                 type="text"
                  autoComplete="off"
                   placeholder="نام و نام خانوادگی"
                    className="rgc-profile-input"
                    onKeyDown={handleEnter}
                    />
              </Form.Group>

              <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicNumber">
                <Form.Label>شماره همراه</Form.Label>
                <i className="fas fa-mobile-alt" aria-hidden="true"></i>
                <Form.Control
                 type="number" 
                 autoComplete="off" 
                 placeholder="شماره همراه" 
                 className="rgc-profile-input"
                 onKeyDown={handleEnter}
                 />
              </Form.Group>

              <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicCode">
                <Form.Label>کد ملی</Form.Label>
                <i className="fa fa-id-card" aria-hidden="true"></i>
                <Form.Control 
                type="number" 
                autoComplete="off" 
                placeholder="کد ملی" 
                className="rgc-profile-input"
                onKeyDown={handleEnter}
                />
              </Form.Group>

              <Form.Group className="mb-3  rgc-input-icons" controlId="formBasicPassword">
                <Form.Label>رمز عبور</Form.Label>
                <span onClick={togglePasswordVisiblity}>
                   {visibility ?    <i className="fa fa-eye" aria-hidden="true" ></i>:
                   <i className="fa fa-eye-slash" aria-hidden="true"></i>
                   }
                </span>                
                <Form.Control
                 autoComplete="off"  
                 type={passwordShown ? "text" : "password"}
                 placeholder="رمز عبور" 
                className="rgc-profile-input"
                onKeyDown={handleEnter}
                />
              </Form.Group>

              <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicPassword1">
                <Form.Label>تکرار رمز عبور</Form.Label>
                <span onClick={togglePasswordVisiblity2}>
                   {visibility2 ?    <i className="fa fa-eye" aria-hidden="true" ></i>:
                   <i className="fa fa-eye-slash" aria-hidden="true"></i>
                   }
                </span>                
                <Form.Control 
                autoComplete="off" 
                type={passwordShown2 ? "text" : "password"} 
                placeholder="رمز عبور" className="rgc-profile-input"                
                />
              </Form.Group>

            </Form>
          </Col>
          <Col xs={12} className="text-center">
            <Button className="rgc-orderreg-btn rgc-order-btn-sub" >
              ارسال
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Profile;
